import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import Section from "@/components/Section";
import AIForLeaders from "@/components/AIForLeaders";
import AILyftet from "@/components/AILyftet";
import AIMasterclass from "@/components/AIMasterclass";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";
import { useLanguage } from "@/i18n/useLanguage";

const AISkilling = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  return (
    <>
      <SeoHead
        title={{
          en: "AI-skilling Programs | AI-labbet",
          sv: "AI-kompetens & utbildning | AI-labbet",
        }}
        description={{
          en: "AI training programs for leaders and teams. Part of our Transformation & enablement business area – capability that drives real change.",
          sv: "AI-utbildningar för ledare och team. En del av vårt affärsområde Transformation & enablement – kompetens som driver verklig förändring.",
        }}
        path="/ai-skilling"
      />

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <PageBreadcrumb currentPage="aiSkilling" />

        <main className="flex-1">
          <h1 className="sr-only">AI-skilling Programs</h1>

          {/* Intro: positions AI-skilling as part of Transformation & enablement */}
          <Section
            eyebrow={t("aiSkillingIntro.eyebrow")}
            title={t("aiSkillingIntro.title")}
            titleAs="h2"
            description={t("aiSkillingIntro.body")}
            align="left"
            containerSize="narrow"
          >
            <Link
              to={localize("/services#transformation-enablement")}
              className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all"
            >
              <Sparkles className="w-4 h-4" />
              {t("aiSkillingIntro.ctaServices")}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Section>

          <AIForLeaders />
          <AILyftet />
          <AIMasterclass />

          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AISkilling;
